
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import WorkProgress           from './WorkProgress';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterWorkProgress: actions.enterWorkProgress,
        leaveWorkProgress: actions.leaveWorkProgress
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkProgress);



// WEBPACK FOOTER //
// ./src/app/views/workProgress/index.js